export default "__VITE_ASSET__6g0OdQBU__"